export default {"src":"/_next/static/media/ozon-light-min.c82b8d94.svg","height":12,"width":56};